import { Category } from '../category';

export class Creative {
  constructor(
    public readonly id: string,
    public readonly username: string,
    public readonly category: Category | undefined,
    public readonly profileImage: string | null,
    public readonly status: 'Pending' | 'Rejected' | 'Published',
    public readonly timestamp: string,
    public readonly totalPendingPost: number
  ) {}
}
